import React, { useEffect, useState } from 'react'
import { Editor } from 'react-draft-wysiwyg'
import { EditorState } from 'draft-js'
import Box from '@mui/material/Box'
import Modal from '@mui/material/Modal'
import PostAddIcon from '@mui/icons-material/PostAdd'
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css'
import styles from './ContactForm.module.scss'
import { convertToHTML } from 'draft-convert'
import PropTypes from 'prop-types'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 'fit-content',
  minWidth: '860px',
  bgcolor: 'background.paper',
  border: '1px solid #d8e2ec',
  boxShadow: 24,
  p: 4
}

const ContactForm = ({ open, setOpen, notifyPatient }) => {
  const [stateRaw, setStateRaw] = useState(null)
  const [stateHTML, setStateHTML] = useState(null)

  const [editorState, setEditorState] = useState(() =>
    EditorState.createEmpty()
  )

  const handleClose = () => {
    setEditorState(EditorState.createEmpty())
    setStateRaw(null)
    setStateHTML(null)
    setOpen(false)
  }

  const saveContent = () => {
    setStateRaw(editorState.getCurrentContent().getPlainText())
    setStateHTML(convertToHTML(editorState.getCurrentContent()))
  }

  useEffect(() => {
    if (stateRaw && stateHTML) {
      notifyPatient({ stateRaw, stateHTML })
      handleClose()
    }
  }, [stateRaw, stateHTML])

  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={style}>
        <div className={styles.modal__header}>
          <PostAddIcon />
          Notify Patient
        </div>
        <div className={styles.modal__editor}>
          <Editor
            editorState={editorState}
            onEditorStateChange={setEditorState}
          />
        </div>
        <div className={styles.modal__btns}>
          <button onClick={handleClose}>Cancel</button>
          <button
            onClick={saveContent}
            disabled={editorState.getCurrentContent().getPlainText() === ''}
            style={{
              opacity:
                editorState.getCurrentContent().getPlainText() === '' ? 0.5 : 1
            }}
          >
            Send
          </button>
        </div>
      </Box>
    </Modal>
  )
}

ContactForm.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func,
  notifyPatient: PropTypes.object
}

export default ContactForm
